/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {GetRequest} from "../../lib/AxiosHelper";
import {API_CONSOLIDATION} from "../../const/Api";
import {ALERT_VARIANT} from "../../const/dataEnum";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import PeriodDropdown from "../../components/CommonDropdown/PeriodDropdown";
import DepartmentDropdown from "../../components/CommonDropdown/DepartmentDropdown";
import PracticeDropdown from "../../components/CommonDropdown/PracticeDropdown";
import LoadingComponent from "../../components/LoadingComponent";
import {ExportToExcel} from "../../components/ExportToExcel";

export default function ConsolidationTable() {
  const dispatch = useDispatch();

  const [periodId, setPeriodId] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedPractice, setSelectedPractice] = useState(null);

  const [loadingTable, setLoadingTable] = useState(false);

  const [exportData, setExportData] = useState([]);
  const [exportFileName, setExportFileName] = useState([]);

  useEffect(() => {
    if (periodId && selectedDepartment?.id && selectedPractice?.id)
      generateTable(periodId, selectedDepartment, selectedPractice);
  }, [periodId, selectedDepartment, selectedPractice]);

  function generateTable(selectedPeriodID, selectedDepartment, selectedPractice) {
    setLoadingTable(true);
    GetRequest(dispatch, API_CONSOLIDATION + `/${selectedPeriodID}/${selectedDepartment.id}/${selectedPractice.id}`)
      .then((response) => {
        const {data, message, responseCode} = response.data;
        if (responseCode === 0) {
          if (data === null || data.length <= 0) {
            setExportData([]);
          } else {
            let tempExportData = [];
            data.forEach((con, i) => {
              let exportRow = {Name: con.employee.fullName};

              con.generalReviews.forEach((gr, gri) => {
                if (gr.genericReviewQuestion.questionType.startsWith("score")) {
                  exportRow[gr.genericReviewQuestion.question] = gr.score;
                }
              });

              con.skillReviews.forEach((sr, sri) => {
                exportRow[sr.skill.name] = sr.score;
              });

              con.projects.forEach((p, pi) => {
                exportRow[`Project#${pi + 1}`] = p.projectName;
              });

              tempExportData.push(exportRow);
            });

            setExportFileName(
              `Consolidated_${selectedDepartment.departmentName}_${selectedPractice.practiceName}_${selectedPeriodID}`
            );
            setExportData(tempExportData);
          }
        } else if (responseCode < -1) {
          setExportData([]);
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: message}));
        }
      })
      .catch((error) => {
        // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
      })
      .finally(() => {
        setLoadingTable(false);
      });
  }

  const selection = (
    <div className="row mb-4 px-2">
      <div className="col-md-6 col-lg-6 col-sm-12 p-2">
        <PeriodDropdown
          callbackChangePeriod={(value) => {
            if (value !== null) {
              setPeriodId(value.id);
            } else {
              setPeriodId(0);
            }
          }}
        />
      </div>
      {/* Commented because manager can only read their department's data */}
      <div className="col-md-6 col-lg-6 col-sm-12 p-2" style={{display: "none"}}>
        <DepartmentDropdown
          callbackChangeDepartment={(value) => {
            setSelectedDepartment(value);
          }}
        />
      </div>
      <div className="col-md-6 col-lg-6 col-sm-12 p-2">
        <PracticeDropdown
          callbackChangePractice={(value) => {
            setSelectedPractice(value);
          }}
          department={selectedDepartment}
        />
      </div>
    </div>
  );

  const consolidated_reviews_table = (
    <div className="mt-4" style={{marginTop: "-25px"}}>
      {loadingTable ? (
        <div className="text-center">
          <LoadingComponent/>
        </div>
      ) : exportData === null ? (
        "Please select your criteria, and then press the button"
      ) : exportData.length === 0 ? (
        "Based on your selection criteria there are no completed consolidated reviews yet"
      ) : (
        <ExportToExcel apiData={exportData} fileName={exportFileName}/>
      )}
    </div>
  );

  return (
    <div className="container mb-4">
      {selection}
      {consolidated_reviews_table}
    </div>
  );
}
